import { Input as InputComponent } from '@/components/ui/input';
import { cn } from '@/lib/utils';

interface InputProps extends React.ComponentProps<'input'> {
  placeHolder: string;
  helperText?: string;
  rightComponent?: React.ReactNode;
}

function Input({
  value,
  name,
  onChange,
  onKeyDown,
  placeHolder,
  helperText,
  readOnly = false,
  type = 'text',
  rightComponent,
  className,
  ...props
}: InputProps) {
  return (
    <div>
      <div className="relative">
        <InputComponent
          value={value}
          name={name}
          onChange={onChange}
          onKeyDown={onKeyDown}
          placeholder={placeHolder}
          type={type}
          className={cn(className, 'focus-visible:ring-0')}
          disabled={readOnly}
          {...props}
        />
        {rightComponent && (
          <div className="absolute right-2 top-1/2 -translate-y-1/2">{rightComponent}</div>
        )}
      </div>
      {helperText && (
        <div className="mt-1 ml-2">
          <div className="text-sm text-legacy-red-300">{helperText}</div>
        </div>
      )}
    </div>
  );
}

export default Input;
